"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SvcBillingAutomationMobileClient = void 0;
const axios_1 = __importDefault(require("axios"));
class SvcBillingAutomationMobileClient {
    constructor(url, configClient) {
        var _a;
        const config = {
            baseURL: url,
            headers: {
                common: { Accept: 'application/json', 'X-Source-Client': configClient.clientSource },
                delete: {},
                get: {},
                head: {},
                patch: { 'Content-Type': 'application/json' },
                post: { 'Content-Type': 'application/json' },
                put: { 'Content-Type': 'application/json' },
            },
            timeout: (_a = configClient === null || configClient === void 0 ? void 0 : configClient.timeout) !== null && _a !== void 0 ? _a : 5000,
        };
        const client = axios_1.default.create(config);
        this.clientWithoutRetry = this.clientWithRetry = client;
    }
}
exports.SvcBillingAutomationMobileClient = SvcBillingAutomationMobileClient;
//# sourceMappingURL=SvcBillingAutomationMobileClient.js.map